"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeform = void 0;
var base = 'https://feather-insurance.typeform.com';
var privateHealthTypeForm = base + "/to/FX50S6Nh";
exports.typeform = {
    studentHealth: {
        exemptionLetter: base + "/to/UCOfar",
        universityCheck: base + "/to/cXRxnPpJ",
    },
    privateHealth: {
        hanseMerkur: privateHealthTypeForm + "?insurance=HanseMerkur",
        allianz: privateHealthTypeForm + "?insurance=Allianz",
        ottonova: privateHealthTypeForm + "?insurance=OttonovaHealthtool",
        germanPreQuote: base + "/to/OCYr49it",
    },
    affiliate: base + "/to/HJbO6u86",
    support: base + "/to/f3nNrCtc",
    base: base,
};
